import { AppDispatch } from '../../../store'
import { IUserHr } from '../../../User/UsersHr/interfaces/IUserHr'
import Client from '../Client/Client'
import { IPunchclockTime } from '../Client/IPunchclockTime'

import {
  ActionTypes,
  GET_PUNCHCLOCK_TIMES,
  GET_PUNCHCLOCK_TIMES_FAILURE,
  GET_PUNCHCLOCK_TIMES_SUCCESS,
  START_PUNCHCLOCK_TIME,
  START_PUNCHCLOCK_TIME_FAILURE,
  START_PUNCHCLOCK_TIME_SUCCESS,
  END_PUNCHCLOCK_TIME,
  END_PUNCHCLOCK_TIME_FAILURE,
  END_PUNCHCLOCK_TIME_SUCCESS,
} from './ActionTypes'

export const getPunchclockTimes = () => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: GET_PUNCHCLOCK_TIMES,
    })

    return Client.getPunchclockTimes().then(
      (punchclockTimes: IPunchclockTime[]) =>
        dispatch(getPunchclockTimesSuccess(punchclockTimes)),
      () => dispatch(getPunchclockTimesFailure()),
    )
  }
}

const getPunchclockTimesSuccess = (
  punchclockTimes: IPunchclockTime[],
): ActionTypes => {
  return {
    type: GET_PUNCHCLOCK_TIMES_SUCCESS,
    payload: {
      times: punchclockTimes,
    },
  }
}

const getPunchclockTimesFailure = (): ActionTypes => {
  return {
    type: GET_PUNCHCLOCK_TIMES_FAILURE,
  }
}

export const startPunchclockTime = (user: IUserHr) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: START_PUNCHCLOCK_TIME,
    })

    return Client.startPunchclockTime(user).then(
      (punchclockTime: IPunchclockTime) =>
        dispatch(startPunchclockTimesSuccess(punchclockTime)),
      () => dispatch(startPunchclockTimesFailure()),
    )
  }
}

const startPunchclockTimesSuccess = (
  punchclockTime: IPunchclockTime,
): ActionTypes => {
  return {
    type: START_PUNCHCLOCK_TIME_SUCCESS,
    payload: {
      time: punchclockTime,
    },
  }
}

const startPunchclockTimesFailure = (): ActionTypes => {
  return {
    type: START_PUNCHCLOCK_TIME_FAILURE,
  }
}

export const endPunchclockTime = (user: IUserHr) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: END_PUNCHCLOCK_TIME,
    })

    return Client.endPunchclockTime(user).then(
      (punchclockTime: IPunchclockTime) =>
        dispatch(endPunchclockTimesSuccess(punchclockTime)),
      () => dispatch(endPunchclockTimesFailure()),
    )
  }
}

const endPunchclockTimesSuccess = (
  punchclockTime: IPunchclockTime,
): ActionTypes => {
  return {
    type: END_PUNCHCLOCK_TIME_SUCCESS,
    payload: {
      time: punchclockTime,
    },
  }
}

const endPunchclockTimesFailure = (): ActionTypes => {
  return {
    type: END_PUNCHCLOCK_TIME_FAILURE,
  }
}
